import { toast } from "sonner";
import { removeTokens } from "../utils/cacheStorage";

let lastErrorMessage: string | null = null;

const toToastMessage = (message: unknown, fallback: string): string => {
  if (typeof message === "string" && message.trim()) {
    return message;
  }

  if (message && typeof message === "object") {
    const nestedMessage = (message as { message?: unknown }).message;
    if (typeof nestedMessage === "string" && nestedMessage.trim()) {
      return nestedMessage;
    }
  }

  return fallback;
};

export const errorView = (
  err: any,
  options?: {
    force?: boolean;
  }
) => {
  const { force = true } = options || {};

  const status = err?.response?.status;
  const statusText = err?.response?.statusText || "Something went wrong";
  const responseMessage = err?.response?.data?.message;

  let finalMessage: string;

  if (typeof err === "string") {
    finalMessage = err;
  } else if (status === 401) {
    removeTokens();
    finalMessage = toToastMessage(responseMessage, statusText || "Unauthorized access");
  } else {
    finalMessage = toToastMessage(responseMessage, statusText || "Something went wrong");
  }

  if (!finalMessage) return;

  // prevent duplicate toast unless forced
  if (!force && finalMessage === lastErrorMessage) return;

  lastErrorMessage = finalMessage;
  toast.error(finalMessage, { style: { background: "#fff" } });
};

export const errorApi = async (err: any) => {
  if (typeof err !== "string" && err.response.status === 401) {
    toast.error(err?.response?.statusText || "Something went to wrong", {
      style: { background: "#fff" }
    });
  } else {
    toast.error(
      typeof err !== "string"
        ? err?.response?.data?.errors?.[0]?.message
        : typeof err === "string"
        ? err
        : "Something went to wrong",
      { style: { background: "#fff" } }
    );
  }
};

export const errorViewBank = async (error: any) => {
  if (error?.code === "routing_number_invalid") {
    toast.error(error?.message || "Something went to wrong", { style: { background: "#fff" } });
  }
  if (error?.code === "account_number_invalid") {
    toast.error(error?.message || "Something went to wrong", { style: { background: "#fff" } });
  }
};

export const successMessage = async (message: unknown) => {
  toast.success(toToastMessage(message, "Success"), { style: { background: "#fff" } });
};

export const warningMessage = async (message: unknown) => {
  toast.warning(toToastMessage(message, "Warning"), { style: { background: "#fff" } });
};
